import React, { useState } from 'react';
import { Box, Button, ButtonMode, PlusIcon } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { SupportGuidesProps } from '@epi-models/pages/Support';

import { SupportTiles } from '../SupportTiles';

export const SupportGuides = ({ data }: SupportGuidesProps) => {
  const { t } = useTranslation();
  const { gray10, fontSemiBold, sizeExtraLarge } = useTheme();
  const [showMore, setShowMore] = useState(false);

  const handleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <>
      {data.map(({ videos, links, title_id }) => (
        <Box mt={6} mb={2} key={title_id} border={`1px solid ${gray10}`} p={5}>
          <Box
            id={`support-page-link-title-${title_id}`}
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Box fontSize={sizeExtraLarge} fontWeight={fontSemiBold}>
              {t(`containers.help.guides.${title_id}`)}
            </Box>
            {videos && videos.length > 4 && (
              <Button
                id={`support-page-button-${title_id}`}
                mode={ButtonMode.Secondary}
                onClick={handleShowMore}
              >
                <Box display="flex" gap={1.5} alignItems="center">
                  <PlusIcon /> {t('containers.help.guides.show_more')}
                </Box>
              </Button>
            )}
          </Box>
          {videos && (
            <Box
              display="grid"
              gridTemplateColumns="repeat(4, 1fr)"
              gap="40px"
              mt={3}
            >
              {videos.slice(0, 4).map(video => (
                <SupportTiles key={video.id} type="video" {...video} />
              ))}
              {showMore &&
                videos
                  .slice(4)
                  .map(video => (
                    <SupportTiles key={video.id} type="video" {...video} />
                  ))}
            </Box>
          )}
          {links && (
            <Box
              display="grid"
              gridTemplateColumns="repeat(4, 1fr)"
              gap="40px"
              mt={3}
            >
              {links.map(link => (
                <SupportTiles key={link.id} type="guide" {...link} />
              ))}
            </Box>
          )}
        </Box>
      ))}
    </>
  );
};
